<template lang="pug">
  div.background
    slot
</template>

<style lang="scss" scoped>
.background {
  min-height: 100%;
  width: 100%;
  background-color: #101c2a;
  overflow: auto;
}
</style>

<script>
export default {}
</script>
